import React from 'react';
import { DEFAULT_INFO_CARDS } from 'constants/cardDefaults';
import { useQueryParams } from 'utils/urlUtilities';
import { browserRedirect } from 'utils/window';

import CardGroupBlock from '../../components/blocks/CardGroupBlock/CardGroupBlock';
import PPQNegativeOutcome from './components/PPQNegativeOutcome';
import PPQPositiveOutcome from './components/PPQPositiveOutcome';

const validateResults = (params) => {
  if (!params.result) {
    browserRedirect('/');
  }
};

const PPQResultController = ({ partnerName }) => {
  const params = useQueryParams();

  let output;
  if (params?.result === 'qualified') {
    output = <PPQPositiveOutcome inviteLink={params.invite_link} partnerName={partnerName} />;
  } else if (params?.result === 'not-qualified') {
    output = <PPQNegativeOutcome failedReasons={params} />;
  } else {
    output = validateResults(params);
  }

  return (
    <>
      <div className="PPQOutcome" key="ready">
        {output}
      </div>
      {params?.result === 'qualified' && (
        <div>
          <CardGroupBlock
            theme="medium"
            heading="Resources"
            text="Learn more to see how partnering with Hometap can benefit your audience:"
            cardType="InfoCard"
            cards={DEFAULT_INFO_CARDS}
          />
        </div>
      )}
    </>
  );
};

export default PPQResultController;
